import { formatData } from '../../../../helpers/data_format';

export interface MetadataItemProps {
  format?: string;
  name?: string;
  value: number | string;
}

const MetadataItem = ({ format, name, value }: MetadataItemProps) => {
  return (
    <li>
      <span>{name}</span>
      <span>{formatData({ format, value })}</span>
    </li>
  );
};

export default MetadataItem;
